interface IAppLoggerProps {
    level: 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'fatal'
    name: string
    message: string
}

export const appLogger = async ({
    level,
    name,
    message
}: IAppLoggerProps): Promise<void> => {
    console.warn('[BETSLIP] appLogger()', level, name, message)
    // const url = `/logs` // TODO: Implement the logs route
    // await fetch(url, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({
    //         level,
    //         data: {
    //             name,
    //             message
    //         }
    //     })
    // })
}
